import './style.css';


function RadioWidgetPlain({value, variants = ["yes", "no"], title, onChange, labels = ["так", "ні"], id, isError, readOnly=false }){

    return(      
        <div className={`form-row-plain`}>
            <div className="form-group">
            <label className="form-label">{title}</label>
            <div className="radio-group">
                <div className="radio-item">
                <input
                    className="radio-input"
                    type="radio"
                    name={id + 'yes'}
                    id={id + 'yes'}
                    value={variants[0]}
                    checked={value == variants[0]}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={readOnly}
                />
                <label className="radio-label" htmlFor={id + 'yes'}  style={isError ? {color: "red"} : {}}>{labels[0]}</label>
                </div>
                <div className="radio-item">
                <input
                    className="radio-input"
                    type="radio"
                    name={id+'no'}
                    id={id+'no'}
                    value={variants[1]}
                    checked={value == variants[1]}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={readOnly}
                />
                <label className="radio-label" htmlFor={id+'no'}  style={isError ? {color: "red"} : {}}>{labels[1]}</label>
                </div>
            </div>
            </div>
        </div>
    )
};

export default RadioWidgetPlain;